import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomSelect from '../common/CustomSelect';
import CommonInput from '../common/CommonInput';
import { arrayOptionsCarScale, arrayOptionsCarYear } from '../../../util/optionlist';
import { useRecoilState } from 'recoil';
import { carInfoState } from '../../../recoil/atom';

function PopupBtmNotInputCarInfo({carNumber}) {
  const navigate = useNavigate();
  const [inputValueCarNumber, setinputValueCarNumber] = useState(carNumber);
  const [inputValueCarName, setinputValueCarName] = useState('');
  const [selectOptionCarScale, setselectOptionCarScale] = useState('');
  const [selectOptionCarYear, setselectOptionCarYear] = useState('');
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [carInfo, setCarInfo] = useRecoilState(carInfoState);

  useEffect(() => {
    // Check if all fields are filled
    const isComplete = 
      inputValueCarNumber.trim() !== '' &&
      inputValueCarName.trim() !== '' &&
      selectOptionCarScale !== '' &&
      selectOptionCarYear !== '';

    setIsFormComplete(isComplete);
  }, [inputValueCarNumber, inputValueCarName, selectOptionCarScale, selectOptionCarYear]);

  const handleCompletion = () => {
    if (isFormComplete) {
      // 챗봇에 전달할 차량 정보 객체 생성
      const carInfoData = {
        carNumber: inputValueCarNumber,
        carName: inputValueCarName,
        carScale: selectOptionCarScale,
        carYear: selectOptionCarYear,
        carRegion: carInfo.carRegion,
        carReservationDate: carInfo.carReservationDate,
        carRepairPart: carInfo.carRepairPart,
        userName: carInfo.userName,
        userPhoneNumber: carInfo.userPhoneNumber,
        userRequest: carInfo.userRequest,
      };
      setCarInfo(carInfoData);

      // chatbot 페이지로 이동
      navigate('/chatbot');
    }
  };

  return (
    <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10">
      <div className="bg-[#fff] w-full p-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-auto flex flex-col flex-wrap justify-end relative">
        <button className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl">
          <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
        </button>
        <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] mb-4">
          사고 차량 정보를 입력해주세요.
        </h3>

        <p className="text-[#46474C] text-[13px]">차량번호</p>
        <CommonInput
          inputValue={inputValueCarNumber}
          setInputValue={setinputValueCarNumber}
          placeholder={'ex) 122fn 1234'}
        />

        <p className="text-[#46474C] text-[13px] mt-4">차량명</p>
        <CommonInput
          inputValue={inputValueCarName}
          setInputValue={setinputValueCarName}
          placeholder={'ex) 벤츠 E33 2.0'}
        />

        <p className="text-[#46474C] text-[13px] mt-4">차량규모</p>
        <CustomSelect
          placeholder={'차량 규모를 선택해주세요'}
          selectOption={selectOptionCarScale}
          setselectOption={setselectOptionCarScale}
          options={arrayOptionsCarScale}
        />

        <p className="text-[#46474C] text-[13px] mt-4">연식</p>
        <CustomSelect
          placeholder={'연식을 선택해주세요'}
          selectOption={selectOptionCarYear}
          setselectOption={setselectOptionCarYear}
          options={arrayOptionsCarYear}
        />

        <div className="flex justify-between mt-8 gap-[10px]">
          <button
            onClick={handleCompletion}
            className={`flex items-center justify-center w-full h-[52px] rounded-lg ${
              isFormComplete 
                ? 'bg-[#313A4C] text-white cursor-pointer'
                : 'bg-[#F4F4F5] text-[#C2C4C8] cursor-not-allowed'
            }`}
            disabled={!isFormComplete}
          >
            완료
          </button>
        </div>
      </div>
    </div>
  );
}

export default PopupBtmNotInputCarInfo;